import { create } from "zustand";

const useNowStore = create<{ now: Date }>(() => ({ now: new Date() }));

setInterval(() => useNowStore.setState({ now: new Date() }), 1000);

export function useNow(): Date {
  return useNowStore().now;
}
